import { SIGNIFICANT_CENTER_COUNT } from '../hero/constants'
import { isNonEmptyString } from '../../utils/checks'
import { isLocationCity } from '../location/useCases/isLocationCity'

export const getHeroDescription = (
  isUSLocation,
  count,
  title,
  shouldDefaultRegionalize,
  location
) => {
  const parentLocation = location?.parentLocation
  const locationForHero =
    isNonEmptyString(parentLocation) && isLocationCity(location)
      ? `${title}, ${parentLocation}`
      : title
  const rehabType = shouldDefaultRegionalize ? 'centres' : 'centers'
  const globalDescription = `<strong>The best rehab is one that meets your needs.</strong> Our research team evaluated <a style="text-decoration: underline" href="#browse-all">${
    count > SIGNIFICANT_CENTER_COUNT ? count : ''
  } alcohol and drug rehabs in ${locationForHero}.</a> Review our curated list of rehab ${rehabType} providing detox, residential, and outpatient treatment.`

  if (isUSLocation) {
    return `${globalDescription} Insurance covers rehab for addiction, making recovery more accessible and affordable.`
  }
  return globalDescription
}
